import React from 'react';
import { Link } from 'react-router-dom';
import { cities, merchants } from '../lib/data';
import { ChevronRight, Search } from 'lucide-react';
import { MetaTags } from '../components/seo/MetaTags';
import { generateStaticPageMeta } from '../lib/seo/generators';

export function CategoriesPage() {
  const meta = generateStaticPageMeta('CATEGORIES');

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <MetaTags {...meta} />

      <div className="container mx-auto px-4">
        <div className="mb-8">
          <nav className="flex items-center text-sm text-gray-500 mb-4">
            <Link to="/" className="hover:text-yellow-600">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-gray-900">Categories</span>
          </nav>
          <h1 className="text-3xl font-bold text-gray-900">Equipment Hire Categories</h1>
          <p className="text-gray-600 mt-2">Browse equipment hire services by category and location across the UK</p>
        </div>

        {merchants.map((merchant) => (
          <div key={merchant.slug} className="mb-12">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-semibold text-gray-900">
                {merchant.name}
              </h2>
              <Link
                to={`/${merchant.slug}`}
                className="text-yellow-600 hover:text-yellow-700 flex items-center gap-1"
              >
                <span>View all locations</span>
                <ChevronRight className="w-4 h-4" />
              </Link>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {cities.slice(0, 12).map((city) => (
                <Link
                  key={`${merchant.slug}-${city.slug}`}
                  to={`/${merchant.slug}/${city.slug}`}
                  className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow group"
                >
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-yellow-600 transition-colors">
                    {merchant.name} in {city.name}
                  </h3>
                  <div className="flex items-center gap-2 mt-2 text-sm text-gray-600">
                    <Search className="w-4 h-4" />
                    <span>Find local providers</span>
                  </div>
                </Link>
              ))}
            </div>

            {cities.length > 12 && (
              <div className="mt-4 text-center">
                <Link
                  to={`/${merchant.slug}`}
                  className="inline-flex items-center gap-2 text-yellow-600 hover:text-yellow-700"
                >
                  <span>View all {cities.length} locations</span>
                  <ChevronRight className="w-4 h-4" />
                </Link>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}